<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
  <div class="home">
    <div class="container-fluid padding-zero bg_pepio " style="min-height: 100vh;">
        <div class="container-fluid padding-zero bg_pepio2" style="min-height: 100vh;">
            <div class="container-fluid ">
              <div class="container padding_categoria">
                <router-view/>

                <Footer/>
              </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script setup>
  import Footer from '@/components/Footer.vue'
</script>